export default "__VITE_ASSET__79a93938__"